<template>
  <div>
    <div>
      <h5 class="pop_tit window-header"><!-- 타이틀바 -->
        입금오류 수동처리
        <span class="right">
          <span class="pop_close" @click="$emit('close')"></span><!-- 닫기 -->
        </span>
      </h5>
    </div>
    <div style="padding: 10px;">

        <h1>입금오류 금액 : <span class="amt_red">{{ can_amt | comma }}</span> 원
          <small v-if="items.length > 1">( 미처리된 입금 {{ items.length }}건 합산 금액)</small>
          <button v-if="items.length == 1" class="btn xs org01 ml10" @click="c_item = { pay_amt : 0 }">전액환불</button>
        </h1>

          <br/>
        <!-- <h2>완료가능한 구매신청 목록 <small> (동일한 계좌번호이고 입금액 {{ can_amt | comma }}원과 같거나 작은 신청) </small></h2> -->
        <h2>수동처리 가능한 신청 내역</h2>
        <table class="tbl01 mysel">
          <thead>
            <tr>
              <th rowspan="2" class="no" >순번</th>
              <th rowspan="2" class="day">구입<br/>신청일</th>
              <th rowspan="2">구입 신청 <br/>명의자</th>
              <th colspan="5" width="gubun"> 구분</th>
              <th rowspan="2">금액</th>
              <th rowspan="2">입금은행<br/>입금계좌번호</th>
              <th rowspan="2">입금여부<br/>(마감일시)</th>
              <th rowspan="2" width="50px">선택</th>
            </tr>
            <tr class="gubun_d">
                <th>본안</th>
                <th>민사소액</th>
                <th>민사고액</th>
                <th>신청</th>
                <th>등기</th>
            </tr>
          </thead>
            <tr v-for="(item,i) in list.items.slice(list.listSize * (list.pageNo - 1), list.listSize * list.pageNo)" :key="'inx_'+i"
              :class="{on: c_item.selldt == item.selldt && c_item.sellseq == item.sellseq}">
              <td>{{ list.totalCount - ((list.pageNo -1) * list.listSize) - i }}</td>
              <td>
                {{ item.incmgdt | moment('YYYY.MM.DD.') }}
              </td>
              <td>
                {{ item.membnm  }}
                <div v-if="item.officenm">
                  {{ T.wrap유한(item.officenm) }}
                </div>
              </td>
              <td>{{ item.tnocnt1 }}</td>
              <td>{{ item.tnocnt6 }}</td>
              <td>{{ item.tnocnt7 }}</td>
              <td>{{ item.tnocnt2 }}</td>
              <td>{{ item.tnocnt3 }}</td>
              <td class="ar_amt">{{ item.pay_amt | comma }}</td>
              <td class="ar_amt">신한은행<br/>{{ item.vraccno }}</td>
              <td>
                <p class="red01">{{ item.paystatnm }}</p>
                <!-- [입금여부] : 입금완료, 취소 시 [마감일시]가 안나오도록  -->
                <div v-if="item.paystat != 'OK' && item.paystat != 'CANCEL'">
                  ({{ item.paylimitdt | moment("YYYY.MM.DD HH:mm:ss") }})
                </div>
                <!-- 입금대기일 경우에만 취소버튼 -->
              </td>
              <td>
                <button class="btn xs org01" @click="choice_item(item)">선택</button>
              </td>
            </tr>
            <tr v-if="list.totalCount < 1">
              <td colspan="12">
                조건에 맞는 수동처리 가능한 신청내역이 없습니다.
                <button v-if="items.length == 1" class="btn xs org01 ml10" @click="c_item = { pay_amt : 0 }">{{ can_amt | comma }} 원 전액환불</button>
                <br/>
                <div style="margin-top: 5px; margin-left: 20px; text-align: left">
                [수동처리 가능조건]<br/>
                <p>가. 전액환불</p>
                <p> &nbsp; &nbsp; 수동처리 > 전액환불 > 은행명, 환불계좌번호, 예금주, 통장사본 첨부 > 전액환불신청</p>
                <p>나. 부족분 입금 후 정상처리</p>
                <p> &nbsp; &nbsp; 동일한 가상계좌번호에 부족금 입금 > 입금오류 목록에서 해당 금액 체크박스 선택 > 모아서 수동처리 > 선택 >확인</p>
                </div>
              </td>
            </tr>
        </table>
        <div v-if="list.totalCount > list.listSize" class="paging">
          <p class="num">
            <s-page :pageNo.sync="list.pageNo" :totalCount="list.totalCount" :listSize="list.listSize"/>
          </p>
        </div>


      <div v-if="!_.isEmpty(c_item)" class="mt10">

        <div style="font-size: 18px;">
          입금금액 : <span class="amt_black">{{ can_amt  | comma }}원</span>
          <template v-if="c_item.pay_amt > 0">
          , 선택한 증표 금액 :
            <span class="amt_black">{{ c_item.pay_amt | comma }}원</span>
          </template>
          <template v-if="c_item.pay_amt == 0">
            <span class="amt_red"> 전액환불</span>
            <template v-if="list.totalCount > 0">
              (구매신청건 선택안함)
            </template>
          </template>
          <template v-if="c_item.pay_amt > 0">
          , 차액 (환불금액) : <span class="amt_blue">{{ rf_amt | comma }}원</span>
          </template>
        </div>

        <div v-if="rf_amt > 0">

          <!-- 테이블 : 환불 내용 -->
          <table class="tbl01 sum mt10" style="border: none;">
            <tr>
              <th class="al_t">환불 금액</th>
              <td class="infoamt">
                {{ rf_amt | comma}} 원
                <span class="red01 right"><b>환불금액은 증표명의자의 계좌로만 입금 가능합니다.</b></span>
              </td>
            </tr>
            <tr>
              <th class="al_t">은행명</th>
              <td class="infoamt bankinfo_wrap">
                <li clas="bankinfo_th">
                  <select v-model="sitem.rfbankcode">
                  <option value="" selected="selected">선택</option>
                  <option v-for="item in code.BANKCODE"
                          :value="item.value"
                          :key="item.value">{{item.text}}</option>
                  </select>
                </li>
                <div class="bankinfo">
                  <li>
                    <span>환불 계좌번호 </span>
                    <input type="text" v-model="sitem.rfaccno"  placeholder="000-00-00000">
                  </li>
                  <li><span>예금주 </span><input type="text" v-model="sitem.rfaccname"></li>
                </div>
              </td>
            </tr>
            <tr>
              <th class="al_t">통장사본<br/>(첨부파일)</th>
              <td class="infoamt">

                <i-fileupload name="file1" ref="file1" v-model="file1"
                  :action="$api + '/attach'"
                  autoUpload required
                  kind="bankauth"
                  :exts="'jpeg,jpe,jpg,gif,png,pdf'.split(/,/)"
                  @done="file=>sitem.attachid = file.uuid"
                  >

                  <template v-slot:dropArea="{isDropActive, files}">
                    <div v-if="$mq != 'mobile' && !file1.name" class="file_drag" :style="{ 'background-color': isDropActive ? 'green' : 'gray' }">
                      Drag And Drop
                    </div>
                  </template>

                  <template v-slot:uploadFile="{file, remove}">
                    {{ file.name }} ( 용량 : {{ file.size | comma }} byte )
                    <i-btn class="btn" @click.prevent="remove(file);sitem.attachid=null" :key="file.id">취소</i-btn>
                  </template>

                  <button v-if="!file1 || !file1.name"
                    class="btn gray01 outline btn_filesel">
                    파일선택
                  </button>

                  &nbsp;
                </i-fileupload>

                <div class="mt15">
                  ※ 통장 실물이 없는 경우 계좌개설확인서를 첨부해 주세요. ( jpg,gif,png,pdf )
                </div>
              </td>
            </tr>
          </table>
          <!-- //테이블 : 환불 내용 -->
        </div>


      </div>
      <div class="btn_group mt0">
        <div class="right">
          <template v-if="_.isEmpty(c_item.selldt) && rf_amt > 0 ">
            <button @click="confirm_doit" class="btn red01">전액환불신청</button>
          </template>
          <template v-else-if="!_.isEmpty(c_item)">
            <button @click="confirm_doit" class="btn red01">확인(구매완료{{ rf_amt > 0 ? ' 및 환불신청' : '' }})</button>
          </template>
          <button @click="$emit('close')" class="btn black01">닫기</button>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
let ui
export default {
  props : {
    items: { type: Array, required: true, }, // 선택한 수동처리건들
    parentReload: { type: Function, required: true, },
  },
  data() {
    return {
      code: {},
      list: {
        loading: false,
        items: [],
        totalCount: 0,
        listSize : 5,
        pageNo : 1,
      },
      c_item: {}, // 선택한 아이템
      file1: {}, // 첨부파일
      sitem: {
          rfway       : 'BANK' // 환불수단 : 계좌이체
        , rf_amt      : 0
        , rfbankcode  : ''
        , rfaccno     : ''
        , rfaccname   : ''
        , attachid    : '' // 첨부파일 ID
      },
    }
  },
  computed: {
    can_amt() { return this.items.reduce((t,p)=>t+=p.amt,0) },
    rf_amt() { return _.isEmpty(this.c_item) ? 0 : this.can_amt - this.c_item.pay_amt }, // 환불금액
  },
  created() {
    ui = this.$ui;
  },
  mounted() {
     // 공통코드 로드
    ui.codeLoad("RREFUND, BANKCODE", code => {
      this.code = code
    });
    this.doSearch()
  },
  methods: {
    doSearch() {
      //this.search.iv_incmgdtfr = reaplace(this.)
      ui.httpGetList(this.list
        , '/proc/N_SEL_SELLINFO_LIST'
        , {
            iv_pgsize      : -1
          , iv_page        : this.list.pageNo
          , iv_paystat     : 'MANUAL' // 수동처리용
          , iv_sellclsf    : 'BB0100' // 판매구분 : 판매
          , iv_sellplac    : '' // 'B21100' // 경유처   : 온라인 -- 2020-02-14 : 경유처 상관없이 대상 검색(당연)
          , iv_agntpersnm  : ''
          , iv_agntpersprn : ''
          , iv_selldtfr    : ''
          , iv_selldtto    : ''

          , iv_membnm_owner : ''
          , iv_incmgdtfr    : ''
          , iv_incmgdtto    : ''
          , iv_vraccno      : '' // this.items[0].vraccno // 선택한건과 동일한 계좌만 조회한다. -- 2020-04-14 정민우대리 요청 -- 계좌 상관 없이 매칭
        },
        ret => {
          this.list.items      = _.get(ret, "data.rs2", []).filter(v=>v.pay_amt <= this.can_amt) // 처리가능 금액만
          this.list.totalCount = this.list.items.length
        })
    },
    choice_item(item) {
      this.c_item  = item
    },
    confirm_doit() { // 수동처리 실행
      ui.httpPost('/proc/N_VRTRADE_MANUAL_PROC', {
        // 실제로 선택한 입금내역
        iv_vrtradedt  : this.items.map(m=>m.vrtradedt ).join("#"), // 선택한 가상계좌입금 dt  (pk1)
        iv_vrtradeseq : this.items.map(m=>m.vrtradeseq).join("#"), // 선택한 가상계좌입금 seq (pk2)
        iv_can_amt    : this.can_amt,              // 선택한 입금들의 총합 ( 참고용 )
        // 작업대상 신청건
        iv_sellregdt  : this.c_item.sellregdt || '',
        iv_sellseq    : this.c_item.sellseq   || 0,
        iv_pay_amt    : this.c_item.pay_amt   || 0,   // 참고검증용
        // 환불정보
        iv_rf_amt     : this.rf_amt || 0, // 환불금액 ( 그냥 참고만..)
        iv_rfbankcode : this.sitem.rfbankcode || '',
        iv_rfaccno    : this.sitem.rfaccno    || '',
        iv_rfaccname  : this.sitem.rfaccname  || '',
        iv_attachid   : this.sitem.attachid   || '',
        //
        iv_membclsf : '', // 자동
        iv_membno   : 0, // 자동
        }, ret=> {
          const {msg, status} = ret.data.rs1[0];
          if (status == '0') { // 작업이 정상 완료일때
            this.parentReload()
            ui.alert(msg)
              .then(v=>this.$emit('close'))
          } else {
            this.parentReload()
            ui.alert_error(msg)
              .then(v=>this.$emit('close'))
          }
        })
    }
  },
}
</script>

<style>
.mysel tr.on { background-color:  yellow;  }
.amt_red { color: red; font-weight: bold; font-size: 23px; }
.amt_black { color: black; font-weight: bold; font-size: 23px; }
.amt_blue { color: blue; font-weight: bold; font-size: 23px; }
</style>

<style scoped>
  .tbl01 th { max-width:8%;}
  .tbl01 th.gubun { width:300px;}
  .tbl01 tr.gubun_d th { width:60px; padding: 0; margin: 0}
</style>